import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { StoreService } from 'src/app/modules/components/store/store.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  isDarkMode = true;

  constructor(public auths: AuthService) {}

  ngOnInit(): void {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      this.isDarkMode = false;
      document.body.classList.add('light-mode');
    } else {
      document.body.classList.remove('light-mode');
    }

    // Respond to theme requests from iframes (travel, store)
    window.addEventListener('message', (e: MessageEvent) => {
      if (e.data?.type === 'theme-request') {
        const theme = localStorage.getItem('theme') ?? 'dark';
        (e.source as Window).postMessage({ type: 'theme-response', value: theme }, '*');
      }
    });
  }

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    const theme = this.isDarkMode ? 'dark' : 'light';
    if (this.isDarkMode) {
      document.body.classList.remove('light-mode');
    } else {
      document.body.classList.add('light-mode');
    }
    localStorage.setItem('theme', theme);
    // Broadcast to all iframes (travel, store, etc.)
    document.querySelectorAll('iframe').forEach(frame => {
      frame.contentWindow?.postMessage({ type: 'theme', value: theme }, '*');
    });
  }
}
